<!-- Modal Header -->
<div class="modal-header">
  <div class="header-content">
    <div class="header-left">
      <div class="record-avatar">
        <i class="bi bi-person-vcard"></i>
      </div>
      <div class="record-info">
        <!-- โหมดสร้าง -->
        <div class="record-name" *ngIf="mode === 'create'">
          เพิ่มข้อมูลอ้างอิงผู้ใช้งาน
        </div>
        <div class="record-meta" *ngIf="mode === 'create'">
          <span class="meta-item">กรอกข้อมูลเพื่อเพิ่มรายการใหม่ในตารางอ้างอิง</span>
        </div>

        <!-- โหมดแก้ไข / ดู -->
        <ng-container *ngIf="mode === 'edit'">
          <div class="record-name">
            {{ recordData?.title }}{{ recordData?.name }} {{ recordData?.lastname }}
          </div>
          <div class="record-meta">
            <span class="meta-item">
              <i class="bi bi-credit-card-2-front-fill"></i>
              {{ recordData?.idCardNumber }}
            </span>
            <span class="meta-divider">•</span>
            <span class="meta-item">
              <i class="bi bi-person-badge-fill"></i>
              {{ recordData?.idMember }}
            </span>
          </div>
        </ng-container>
      </div>
    </div>
    <button type="button" class="btn-close-custom" (click)="onCancel()" aria-label="Close">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body">
  <form [formGroup]="editForm" (ngSubmit)="onSubmit()">
    <div class="step-header">
      <h5 class="step-title">
        <i class="me-2"
           [ngClass]="mode === 'create' ? 'bi bi-plus-circle' : (readOnly ? 'bi bi-eye' : 'bi bi-pencil-square')"></i>
        {{ mode === 'create'
            ? 'เพิ่มข้อมูลอ้างอิงผู้ใช้งาน'
            : (readOnly ? 'ดูข้อมูลอ้างอิงผู้ใช้งาน' : 'แก้ไขข้อมูลอ้างอิงผู้ใช้งาน') }}
      </h5>
      <p class="step-subtitle">
        {{ mode === 'create'
            ? 'กรอกข้อมูลเพื่อเพิ่มรายการใหม่ (ไม่บังคับกรอกครบทุกช่อง)'
            : (readOnly
                ? 'ผู้ใช้รายนี้สมัครเข้าระบบแล้ว จึงดูได้อย่างเดียว ไม่สามารถแก้ไขได้'
                : 'แก้ไขข้อมูลได้ทุกฟิลด์ (ไม่บังคับกรอกครบทุกช่อง)') }}
      </p>
    </div>

    <!-- Read-only notice -->
    <div *ngIf="readOnly" class="alert alert-info" role="alert">
      <i class="bi bi-info-circle-fill me-2"></i>
      ผู้ใช้รายนี้ลงทะเบียนในระบบแล้ว ข้อมูลนี้จึงแสดงเพื่อดูอย่างเดียว
    </div>

    <!-- Error Alert -->
    <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
      <i class="bi bi-exclamation-triangle-fill me-2"></i>{{ errorMessage }}
    </div>

    <div class="form-grid">
      <!-- ID Card Number -->
      <div class="form-group full-width">
        <label class="form-label">
          เลขบัตรประชาชน
          <i *ngIf="readOnly"
             class="bi bi-lock-fill lock-icon"
             ngbTooltip="ผู้ใช้ที่สมัครแล้วแก้ไขไม่ได้"
             placement="top"></i>
        </label>
        <input
          type="text"
          class="form-control id-card-input"
          formControlName="idCardNumber"
          [class.is-invalid]="isInvalid('idCardNumber')"
          (input)="onIdCardInput($event)"
          inputmode="numeric"
          autocomplete="off"
          maxlength="17"
          placeholder="เช่น 3 1499 00338 30 1">
        <small class="field-hint" *ngIf="!readOnly">
          <i class="bi bi-info-circle me-1"></i>พิมพ์เฉพาะตัวเลข ระบบจะเว้นวรรคให้อัตโนมัติ (13 หลัก)
        </small>
        <div class="invalid-feedback" *ngIf="isInvalid('idCardNumber')">
          กรุณากรอกเลขบัตรประชาชนให้ครบ 13 หลัก
        </div>
      </div>

      <!-- Title -->
      <div class="form-group">
        <label class="form-label">คำนำหน้า</label>
        <input
          type="text"
          class="form-control"
          formControlName="title"
          placeholder="เช่น นาย, นางสาว">
      </div>

      <!-- ID Member -->
      <div class="form-group">
        <label class="form-label">รหัสสมาชิก</label>
        <input
          type="text"
          class="form-control"
          formControlName="idMember"
          placeholder="เช่น ส.41-1083">
      </div>

      <!-- Name -->
      <div class="form-group">
        <label class="form-label">ชื่อ</label>
        <input
          type="text"
          class="form-control"
          formControlName="name"
          placeholder="ชื่อ">
      </div>

      <!-- Lastname -->
      <div class="form-group">
        <label class="form-label">นามสกุล</label>
        <input
          type="text"
          class="form-control"
          formControlName="lastname"
          placeholder="นามสกุล">
      </div>

      <!-- Expiration Date -->
      <div class="form-group full-width">
        <label class="form-label">วันหมดอายุ</label>

        <!-- ตัวเลือกตลอดชีพ -->
        <div class="form-check exp-lifetime">
          <input
            class="form-check-input"
            type="checkbox"
            id="expLifetime"
            formControlName="expLifetime">
          <label class="form-check-label" for="expLifetime">
            ตลอดชีพ (ไม่มีวันหมดอายุ)
          </label>
        </div>

        <!-- ตัวช่วยกรอกวัน-เดือน-ปี -->
        <div class="exp-date-grid" [class.disabled]="editForm.get('expLifetime')?.value">
          <input
            type="text"
            class="form-control"
            formControlName="expDay"
            inputmode="numeric"
            autocomplete="off"
            maxlength="2"
            placeholder="วันที่"
            (input)="onExpDigitsInput('expDay', 2, $event)">
          <select class="form-select" formControlName="expMonth">
            <option value="">เดือน</option>
            <option *ngFor="let m of months" [value]="m">{{ m }}</option>
          </select>
          <select class="form-select" formControlName="expYear">
            <option value="">ปี (พ.ศ.)</option>
            <option *ngFor="let y of years" [value]="y">{{ y }}</option>
          </select>
        </div>

        <small class="field-hint">
          <i class="bi bi-info-circle me-1"></i>
          รูปแบบที่บันทึก:
          <strong>{{ editForm.get('expirationDate')?.value || 'เว้นว่าง' }}</strong>
        </small>
      </div>
    </div>
  </form>
</div>

<!-- Modal Footer -->
<div class="modal-footer">
  <!-- โหมดดูอย่างเดียว: แสดงเฉพาะปุ่มปิด -->
  <button
    *ngIf="readOnly"
    type="button"
    class="btn btn-primary"
    (click)="onCancel()">
    <i class="bi bi-x-lg me-2"></i>ปิด
  </button>

  <!-- โหมดแก้ไข -->
  <ng-container *ngIf="!readOnly">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="onCancel()"
      [disabled]="isSubmitting">
      ยกเลิก
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="onSubmit()"
      [disabled]="isSubmitting">
      <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      <i *ngIf="!isSubmitting" class="bi bi-check-lg me-2"></i>
      {{ isSubmitting
          ? (mode === 'create' ? 'กำลังเพิ่ม...' : 'กำลังบันทึก...')
          : (mode === 'create' ? 'เพิ่มข้อมูล' : 'บันทึกข้อมูล') }}
    </button>
  </ng-container>
</div>
